import React, { useState } from 'react';
import {
  Button, Card, Col, Form, Row, Badge,
} from 'react-bootstrap';
import { PlusLg } from 'react-bootstrap-icons';
import { makeUID } from '../../helpers';

import Required from '../Required';
import api from '../../api';
import useToast from '../../hooks/useToast';
import ConfirmModal from '../common/ConfirmModal';
import DownloadLink from '../common/DownloadLink';
import FileCard from '../common/FileCard';
import { dateRenderer, floatRenderer } from '../../services/formatSvc';

export default function BuyTeos({
  buyId, files, onChange, readOnly,
}) {
  const addToast = useToast();
  const [selectedFileId, setSelectedFileId] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [showConfirmFileRemoveModal, setShowConfirmFileRemoveModal] = useState(false);

  const handleFileUpload = async ({ target }) => {
    const newFile = target.files.length ? target.files[0] : null;
    if (newFile) {
      const fileResult = await api.postFormData(
        `/buys/${buyId}/teos`,
        {},
        newFile,
          {isJsonValue:true}
      );
      if (!fileResult || fileResult.error) {
        addToast.error(fileResult?.error.message || 'При сохранении документа произошла ошибка');
      } else {
        onChange([fileResult]);
      }
    }
    setEditMode(false);
  };

  const handleFileRemove = async () => {
    if (selectedFileId) {
      const res = await api.del(`/buys/${buyId}/files/${selectedFileId}`);
      if (!res.error) onChange([]);
      else addToast.error('res.error.message');
    }
    setShowConfirmFileRemoveModal(false);
  };

  const handleFileRemoveRequest = (teoId) => {
    setShowConfirmFileRemoveModal(true);
    setSelectedFileId(teoId);
  };

  return (
    <>
      <Card className="mb-4">
        <Card.Header as={Card.Title} className="p-4">ТЭО</Card.Header>
        <Card.Body className="p-4">
          <Row className="mb-4">
            {files.map((f) => (
              <Row key={f.id}>
                <FileCard file={f} onRemove={handleFileRemoveRequest} readOnly={readOnly} />
              </Row>
            ))}
          </Row>
          <Row className="mb-4">
            <Col md={3}>
              <Button variant="primary" hidden={editMode || readOnly} onClick={() => setEditMode(true)}>
                {files.length > 0 ? 'Обновить' : 'Загрузить'}
                {' '}
                документ
              </Button>
            </Col>
            {editMode && (
            <Form.Group as={Col} md="12">
              <Form.Label>Файл</Form.Label>
              <Form.Control onChange={handleFileUpload} type="file" />
              * Размер файла не должен превышать 8 Мбайт
              <br />
              ** Файл должен быть в формате PDF
            </Form.Group>
            )}
          </Row>
        </Card.Body>
      </Card>
      <ConfirmModal
        show={showConfirmFileRemoveModal}
        onConfirm={handleFileRemove}
        onClose={() => setShowConfirmFileRemoveModal(false)}
        message="Файл будет удалён с сервера без возможности восстановления. Вы уверены?"
      />
    </>
  );
}

const cardHeaderColor = '#E3EFFF';
